import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-975e2b74"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-ecosystem",
  "aria-labelledby": "ecosystem-title"
};
const _hoisted_2 = {
  class: "ecosystem-shell"
};
const _hoisted_3 = {
  class: "ecosystem-heading"
};
const _hoisted_4 = {
  id: "ecosystem-title"
};
const _hoisted_5 = {
  class: "ecosystem-grid"
};
const _hoisted_6 = {
  class: "ecosystem-copy"
};
const _hoisted_7 = {
  class: "ecosystem-art",
  "aria-hidden": "true"
};
const _hoisted_8 = ["src"];
import { computed } from 'vue';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import walletImage from '@/assets/home1/ecosystem-wallet.png';
import swapImage from '@/assets/home1/ecosystem-swap.png';
import earnImage from '@/assets/home1/ecosystem-earn.png';
import launchpadImage from '@/assets/home1/ecosystem-launchpad.png';
import nftImage from '@/assets/home1/ecosystem-nft.png';
import chainImage from '@/assets/home1/ecosystem-chain.png';
export default {
  __name: 'HomeEcosystem',
  setup(__props) {
    const router = useRouter();
    const {
      t
    } = useI18n();
    const products = computed(() => [{
      id: 'wallet',
      title: t('homepage.ecosystem.products.wallet.title'),
      description: t('homepage.ecosystem.products.wallet.description'),
      image: walletImage
    }, {
      id: 'swap',
      title: t('homepage.ecosystem.products.swap.title'),
      description: t('homepage.ecosystem.products.swap.description'),
      image: swapImage
    }, {
      id: 'earn',
      title: t('homepage.ecosystem.products.earn.title'),
      description: t('homepage.ecosystem.products.earn.description'),
      image: earnImage
    }, {
      id: 'launchpad',
      title: t('homepage.ecosystem.products.launchpad.title'),
      description: t('homepage.ecosystem.products.launchpad.description'),
      image: launchpadImage
    }, {
      id: 'commodities',
      title: t('homepage.ecosystem.products.commodities.title'),
      description: t('homepage.ecosystem.products.commodities.description'),
      image: nftImage
    }, {
      id: 'indices',
      title: t('homepage.ecosystem.products.indices.title'),
      description: t('homepage.ecosystem.products.indices.description'),
      image: chainImage
    }]);
    const viewAllProducts = () => router.push({
      name: 'spotTrade'
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('homepage.ecosystem.title')), 1), _createElementVNode("button", {
        class: "all-products",
        type: "button",
        onClick: viewAllProducts
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('homepage.ecosystem.allProducts')), 1), _createVNode(_unref(ArrowRightOutlined), {
        "aria-hidden": "true"
      })])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product, index) => {
        return _openBlock(), _createElementBlock("article", {
          key: product.id,
          class: "ecosystem-card",
          style: _normalizeStyle({
            '--product-index': index
          })
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h3", null, _toDisplayString(product.title), 1), _createElementVNode("p", null, _toDisplayString(product.description), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: product.image,
          alt: ""
        }, null, 8, _hoisted_8)])], 4);
      }), 128))])])]);
    };
  }
};